export const environment = {
    production: true,
}

export const $DOMAIN = 'dev-api.axlerate.com'
export const $URI = `https://${$DOMAIN}`;
export const $REST_URI = `${$URI}`;
export const $REST_URI_COMMON = `${$URI}/common`;
export const $SOCKET_URI = `${$URI}`;
export const $APP_URI = location.origin;